/* tslint:disable:max-line-length */
import * as geCampaignType from './guaranteedEarningsCampaign'

// todo(markn): this probably doesn't make sense as a type module? more local to the ui
export enum GEType {
  EXPIRED = 'EXPIRED',
  ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN = 'ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN',
  NO_OFFER_AVAILABLE = 'NO_OFFER_AVAILABLE',
}

export type GERedirectModalProps = {
  type: GEType
  campaign: geCampaignType.GECampaign
}

export const getTitle = guaranteedEarningsRedirectModal => {
  switch (guaranteedEarningsRedirectModal.type) {
    case GEType.EXPIRED:
      return 'Offer has expired'
    case GEType.ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN:
      return geCampaignType.getModalTitle(
        guaranteedEarningsRedirectModal.campaign
      )
    case GEType.NO_OFFER_AVAILABLE:
      return 'Offer not available in your area'
    default:
      return 'Something went wrong'
  }
}

export const getContent = guaranteedEarningsRedirectModal => {
  switch (guaranteedEarningsRedirectModal.type) {
    case GEType.EXPIRED:
      return 'The offer you have selected has expired and is no longer valid. Click "Continue" below to complete the Dasher sign up process.'
    case GEType.ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN:
      return `The zip code you entered is not eligible for this promotion, but we found another promotion that is available in ${
        guaranteedEarningsRedirectModal.campaign.submarket_name
      }. Click "Continue" below to complete your Dasher sign up to be eligible for this new offer.`
    case GEType.NO_OFFER_AVAILABLE:
      return 'Unfortunately, the zip code you entered is not eligible for this promotion. However, if you still want to sign up as a Dasher, click "Continue" below to complete the Dasher sign up process.'
    default:
      return 'Something went wrong'
  }
}

export const isExpiredModal = guaranteedEarningsRedirectModal =>
  guaranteedEarningsRedirectModal.type === GEType.EXPIRED
